/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IScrollerKeyboardListener_$type } from "igniteui-react-core";
/**
 * @hidden
 */
var DataGridScrollerKeyboardListener = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataGridScrollerKeyboardListener, _super);
    function DataGridScrollerKeyboardListener(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    DataGridScrollerKeyboardListener.prototype.onDownArrow = function (a, b) {
        return this.a.hu(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onEnd = function (a, b) {
        return this.a.hv(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onHome = function (a, b) {
        return this.a.hz(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onLeftArrow = function (a, b) {
        return this.a.h0(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onPageDown = function (a, b) {
        return this.a.h1(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onPageUp = function (a, b) {
        return this.a.h2(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onRightArrow = function (a, b) {
        return this.a.h3(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onTab = function (a, b) {
        return this.a.h4(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onUpArrow = function (a, b) {
        return this.a.h5(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onWheel = function () {
        this.a.rg();
    };
    DataGridScrollerKeyboardListener.prototype.onEnter = function (a, b) {
        return this.a.hw(a, b);
    };
    DataGridScrollerKeyboardListener.prototype.onEscape = function () {
        return this.a.hx();
    };
    DataGridScrollerKeyboardListener.prototype.onF2 = function () {
        return this.a.hy();
    };
    DataGridScrollerKeyboardListener.$t = markType(DataGridScrollerKeyboardListener, 'DataGridScrollerKeyboardListener', Base.$, [IScrollerKeyboardListener_$type]);
    return DataGridScrollerKeyboardListener;
}(Base));
export { DataGridScrollerKeyboardListener };
//# sourceMappingURL=DataGridScrollerKeyboardListener.js.map
